import React from 'react';
import {
  Drawer as MuiDrawer,
  DrawerProps as MuiDrawerProps,
  IconButton as MuiIconButton,
  Paper as MuiPaper,
  Typography
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Close } from '@material-ui/icons';

const CloseButton = withStyles({
  root: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
})(MuiIconButton);

const ActionButton = withStyles({
  root: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
})(MuiIconButton);

const StyledDrawer = withStyles({
  paper: {
    borderColor: '#b9b6b6',
    overflow: 'hidden',
  },
})(MuiDrawer);

const Paper = withStyles({
  root: {
    backgroundColor: '#e3e3e3',
  },
})(MuiPaper);

export interface DrawerProps extends MuiDrawerProps, React.PropsWithChildren<{}> {
  actionIcon?: React.ReactNode;
  actionLabel?: string;
  closeIcon?: React.ReactNode;
  closeLabel?: string;
  onClickAction?: React.MouseEventHandler<HTMLButtonElement>;
  onClose?: React.MouseEventHandler<HTMLButtonElement>;
  open?: boolean;
}

const Drawer = ({
  actionIcon,
  actionLabel,
  children,
  closeIcon = <Close />,
  closeLabel = 'Close',
  onClickAction,
  onClose,
  open,
  ...props
}: DrawerProps) => (
  <StyledDrawer
    {...props}
    elevation={10}
    hideBackdrop
    keepMounted
    open={open}
    style={{
      ...props.style,
      position: 'relative'
    }}
    variant='temporary'
  >
    <Paper>
      {children}
    </Paper>
    <CloseButton onClick={onClose}>
      <Typography variant='srOnly'>{closeLabel}</Typography>
      {closeIcon}
    </CloseButton>
    {onClickAction && actionIcon && (
      <ActionButton onClick={onClickAction}>
        {actionLabel && <Typography variant='srOnly'>{actionLabel}</Typography>}
        {actionIcon}
      </ActionButton>
    )}
  </StyledDrawer>
);

export default Drawer;
